/** Markup-on-cost: unit selling = unit cost × (1 + margin% / 100). */
export function sellingFromMargin(unitCost: number, marginPct: number): number {
  const cost = Number(unitCost) || 0;
  const margin = Number(marginPct) || 0;
  return cost * (1 + margin / 100);
}

/** Inverse of sellingFromMargin; returns null when unit cost is zero. */
export function marginFromSelling(unitCost: number, unitSelling: number): number | null {
  const cost = Number(unitCost) || 0;
  if (cost <= 0) return null;
  const selling = Number(unitSelling) || 0;
  return ((selling - cost) / cost) * 100;
}

export function roundBoqMoney(n: number, decimals = 4): number {
  const factor = 10 ** decimals;
  return Math.round((n + Number.EPSILON) * factor) / factor;
}

export function roundBoqMarginPct(n: number): number {
  const x = Number(n);
  if (!Number.isFinite(x)) return 0;
  return Math.round((x + Number.EPSILON) * 100) / 100;
}

/**
 * Unit selling = unitCost × (1 + margin%);
 * line selling = unit selling × quantity.
 * First argument is **unit cost** (materials/ops sum or basic-info unit), not line total.
 */
export function computeBoqSellingPrices(
  unitCost: number,
  quantity: number,
  marginPct: number
): { unitSellingPrice: number; lineSellingTotal: number } {
  const cost = Number(unitCost) || 0;
  const qty = Number(quantity) || 0;
  const unitSellingPrice = roundBoqMoney(sellingFromMargin(cost, marginPct), 4);
  const lineSellingTotal = roundBoqMoney(unitSellingPrice * qty, 2);
  return { unitSellingPrice, lineSellingTotal };
}
